import React, { useEffect, useState } from 'react';
import { getSoundPropsById, i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';

import GameContainer from './GameContainer.js';

import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import MineSweeperCanvas from '../games/MineSweeperCanvas_new.js';
import MineSweeperControls from '../svg/MineSweeperControls';
import FloatingLayerPublic from './FloatingLayerPublic.js';
import ActionLink from '../builder/ActionLink.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	return null;
};

const FlagCounter = ({ flags, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	return (
		<div class="gui_total_points header_block">
			<strong class="label">{i18n("Flags")}</strong>

			<strong>{flags}</strong>
		</div>
	)
};

const MineSweeperClient = ({ stage, ...props }) => {
	const num_initial_flags = stage.Stage?.minesweeper_mines ?? 10;

	const [ num_flags, setNumFlags ] = useState(num_initial_flags);

	const sound_fx = {
		flip:new Howl({ ...getSoundPropsById('card_flip') }),
		flag:new Howl({ ...getSoundPropsById('flag') }),
		unplug:new Howl({ ...getSoundPropsById('unplug') }),
		error:new Howl({ ...getSoundPropsById('error_backflip') }),
		fail:new Howl({ ...getSoundPropsById('fail') }),
		success:new Howl({ ...getSoundPropsById('applause') }),
	};

	const canvas_images = () => {
		const images = [];

		if(isNotEmpty(stage.Stage, 'minesweeper_bomb_image')) {
			images.push({
				id:'minesweeper_bomb_image',
				name:stage.Stage.minesweeper_bomb_image,
				url:stage.Stage.full_minesweeper_bomb_image,
				fit:'contain',
			});
		}

		if(isNotEmpty(stage.Stage, 'minesweeper_flag_image')) {
			images.push({
				id:'minesweeper_flag_image',
				name:stage.Stage.minesweeper_flag_image,
				url:stage.Stage.full_minesweeper_flag_image,
				fit:'contain',
			});
		}

		return images;
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[stage.Stage.minesweeper_bomb_image,stage.Stage.minesweeper_flag_image],
	});

	const game_key = `game_${stage.Stage?.minesweeper_grid ?? 'small'}_${num_initial_flags}`;

	useEffect(() => {
		setNumFlags(num_initial_flags);
	}, [ num_initial_flags ]);

	const onReset = () => {
		setNumFlags(num_initial_flags);
	};

	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			key={game_key}
			{...props}
			stage={final_stage}
			onReset={onReset}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			custom_block={<FlagCounter
				flags={num_flags}
				intl={props.intl}
			/>}
			game_type="minesweeper"
			display_audio_controls={true}
			display_attemps={false}
			auto_start_timer={false}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
			sound_fx={sound_fx}
			attempts_icon='knk-flag'
		>
			<MineSweeperCanvas
				indexed_images={state.images}
				updatePendingFlags={setNumFlags}
			/>
		</GameContainer>
	)
};

export default injectIntl(MineSweeperClient);